firebird.service('automationService', [
    '$rootScope',
    '$injector',
    'videoroomService',
    function ($rootScope, $injector, videoroomService) {
        var self = this;
        //for freeswitch, there are 2 connections. 1 for socket and 1 for freeswitch media stream
        //in the case of socket disconnect,

        self.phoneInfo = undefined;
        self.meetingInfo = undefined;

        self.audioState = {};

        init();

        function init() {}

        this.getPhoneConfInfo = function () {
            return self.phoneInfo;
        };

        //really we want this to be read, so maybe don't have here
        this.setPhoneConfInfo = function (info) {
            self.phoneInfo = info;
        };

        this.getMeetingInfo = function () {
            return self.meetingInfo;
        };

        //really we want this to be read, so maybe don't have here
        this.setMeetingInfo = function (info) {
            self.meetingInfo = info;
        };

        this.getAudioState = function () {
            return self.audioState;
        };

        this.getVertoState = function () {
            var verto = $injector.get('vertoService');
            var ret = {
                isInCall: verto.isInCall(),
                currentCallType: verto.getCurrentCallType(),
                isVertoSocketConnected: verto.isVertoSocketConnected()
            };
            return ret;
        };

        this.getIsLocalVideoBlinded = function () {
            var localService = $injector.get('attendeeService');
            return localService.getIsVideoBlinded();
        };

        this.getLocalVideoTrack = function () {
            var localService = $injector.get('localStreamManagerService');

            if (localService.isLocalVideoTrackActive()) {
                return localService.currentLocalVideoTrack;
            }
        };

        this.getLocalVideoBandwidthMax = function () {
            var localService = $injector.get('vertoService');

            return localService.getLocalVideoBandwidthMax();
        };

        this.getConnectivityState = function () {
            var connectivity = $injector.get('connectivityService');
            var ret = {
                getAudioThroughPhone: connectivity.getAudioThroughPhone()
            };
            return ret;
        };

        this.getPeerConnections = function () {
            var annotation = $injector.get('annotationService');
            var connectionList = [];

            //get annotation sharer
            var tempSharer = annotation.getSharerConnection();
            var tempSharerPc;
            if (tempSharer) {
                tempSharerPc = tempSharer.getRawPeerConnection();
            }
            if (tempSharerPc) {
                connectionList.push({ type: 'annotationSharer', pc: tempSharerPc });
            }

            //get annotation viewers
            var tempList = annotation.getViewerConnections();

            if (tempList) {
                for (var id in tempList) {
                    var temp = tempList[id];
                    if (temp) {
                        var tempC = temp.getRawPeerConnection();
                        connectionList.push({ type: 'annotationViewer', pc: tempC });
                    }
                }
            }

            return connectionList;
        };

        this.preventAutoHideControls = function () {
            $rootScope.$broadcast('enable-header-auto-hide', { enable: false, reason: 'automation' });
        };

        this.enableAutoHideControls = function () {
            $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'automation' });
        };

        this.setNumberOfFeedsToEnableLGV = function (value) {
            videoroomService.setNumberOfFeedsToEnableLGV(value);
        };

        this.setNumberOfFeedsToDisableLGV = function (value) {
            videoroomService.setNumberOfFeedsToDisableLGV(value);
        };

        this.triggerAWVSystemLimit = function (limit) {
            var socketService = $injector.get('socketService');
            var data = {
                message: 'trigger-awv-system-limit',
                data: { limit: limit }
            };

            socketService.send(data);
        };

        this.retrieveAWVUserState = function () {
            var socketService = $injector.get('socketService');
            var data = {
                message: 'retrieve-awv-user-stats',
                callback: function (stats) {
                    console.log(stats);
                }
            };

            socketService.send(data);
        };
    }
]);
